import { createSvgIcon } from "@mui/material";

const FundraisingIcon = createSvgIcon(
  <svg viewBox="0 0 49 48" fill="none">
    <path
      d="M0.600098 12.1905C0.600098 5.45786 6.33085 0 13.4001 0H35.8001C42.8693 0 48.6001 5.45786 48.6001 12.1905V35.8095C48.6001 42.5421 42.8693 48 35.8001 48H13.4001C6.33085 48 0.600098 42.5421 0.600098 35.8095V12.1905Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M27.4544 33.6328C32.1833 33.6328 36.0169 29.7993 36.0169 25.0703C36.0169 20.3414 32.1833 16.5078 27.4544 16.5078C22.7254 16.5078 18.8918 20.3414 18.8918 25.0703C18.8918 29.7993 22.7254 33.6328 27.4544 33.6328Z"
      fill="#B6DEB7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.8792 14.0461C22.0959 14.5138 21.8925 15.0686 21.4248 15.2853C18.813 16.4957 16.9709 19.172 16.9709 22.2161C16.9709 26.41 20.4062 29.8453 24.6001 29.8453C25.551 29.8453 26.508 29.6541 27.3333 29.3367C27.8144 29.1516 28.3544 29.3916 28.5395 29.8728C28.7245 30.3539 28.4845 30.8939 28.0034 31.0789C26.9734 31.4751 25.7898 31.712 24.6001 31.712C19.3752 31.712 15.1042 27.441 15.1042 22.2161C15.1042 18.4102 17.4007 15.0928 20.64 13.5917C21.1076 13.3749 21.6625 13.5784 21.8792 14.0461Z"
      fill="#347D36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3975 13.6133C25.4985 13.1078 25.9902 12.78 26.4957 12.8811C30.8559 13.7531 34.096 17.6321 34.096 22.2161C34.096 24.2559 33.4693 26.25 32.2541 27.7893C31.9347 28.1938 31.3478 28.2629 30.9432 27.9435C30.5386 27.6241 30.4696 27.0372 30.789 26.6326C31.7144 25.4604 32.2293 23.8868 32.2293 22.2161C32.2293 18.523 29.6184 15.4093 26.1296 14.7115C25.6242 14.6104 25.2964 14.1187 25.3975 13.6133Z"
      fill="#347D36"
    />
    <path
      d="M25.171 26.4974H23.8867C22.8163 26.4974 21.8887 25.9266 21.532 25.3557C21.2465 24.9276 21.3893 24.3568 21.746 24.1427C22.1741 23.8573 22.6736 24 22.959 24.3568C23.0304 24.4281 23.3872 24.7135 23.8867 24.7135H25.171C25.6705 24.7135 26.0273 24.3568 26.0273 23.9286C26.0273 23.5005 25.6705 23.1437 25.171 23.1437H24.1721C22.745 23.1437 21.532 22.0021 21.532 20.575C21.532 19.1479 22.745 18.0062 24.1721 18.0062H25.0997C26.5268 18.0062 27.2403 19.0052 27.3117 19.1479C27.5971 19.576 27.4544 20.1469 27.0262 20.3609C26.5981 20.6463 26.0273 20.5036 25.8132 20.0755C25.8132 20.0755 25.5992 19.7901 25.171 19.7901H24.2434C23.7439 19.7901 23.3872 20.1469 23.3872 20.575C23.3872 21.0031 23.7439 21.3599 24.2434 21.3599H25.2424C26.6695 21.3599 27.8825 22.5015 27.8825 23.9286C27.8825 25.3557 26.5981 26.4974 25.171 26.4974Z"
      fill="#347D36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6001 16.5021C25.1155 16.5021 25.5334 16.9199 25.5334 17.4354V18.6484C25.5334 19.1639 25.1155 19.5818 24.6001 19.5818C24.0846 19.5818 23.6667 19.1639 23.6667 18.6484V17.4354C23.6667 16.9199 24.0846 16.5021 24.6001 16.5021Z"
      fill="#347D36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6001 24.8505C25.1155 24.8505 25.5334 25.2684 25.5334 25.7839V26.9969C25.5334 27.5123 25.1155 27.9302 24.6001 27.9302C24.0846 27.9302 23.6667 27.5123 23.6667 26.9969V25.7839C23.6667 25.2684 24.0846 24.8505 24.6001 24.8505Z"
      fill="#347D36"
    />
    <path
      d="M13.5401 12.9401C14.9194 12.9401 16.0375 11.822 16.0375 10.4427C16.0375 9.06344 14.9194 7.94531 13.5401 7.94531C12.1608 7.94531 11.0427 9.06344 11.0427 10.4427C11.0427 11.822 12.1608 12.9401 13.5401 12.9401Z"
      fill="#347D36"
    />
    <path
      d="M24.6002 40.0547C25.9795 40.0547 27.0976 38.9366 27.0976 37.5573C27.0976 36.1781 25.9795 35.0599 24.6002 35.0599C23.2209 35.0599 22.1028 36.1781 22.1028 37.5573C22.1028 38.9366 23.2209 40.0547 24.6002 40.0547Z"
      fill="#347D36"
    />
    <path
      d="M38.5142 33.6329C39.8935 33.6329 41.0116 32.5147 41.0116 31.1355C41.0116 29.7562 39.8935 28.6381 38.5142 28.6381C37.135 28.6381 36.0168 29.7562 36.0168 31.1355C36.0168 32.5147 37.135 33.6329 38.5142 33.6329Z"
      fill="#347D36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9297 9.73675C13.3196 9.39955 13.909 9.44227 14.2462 9.83214L18.8129 15.1124C19.1501 15.5022 19.1074 16.0917 18.7175 16.4288C18.3276 16.766 17.7382 16.7233 17.401 16.3334L12.8343 11.0532C12.4972 10.6633 12.5399 10.0739 12.9297 9.73675Z"
      fill="#347D36"
    />
    <path
      d="M35.66 12.9401C37.0393 12.9401 38.1574 11.822 38.1574 10.4427C38.1574 9.06344 37.0393 7.94531 35.66 7.94531C34.2807 7.94531 33.1626 9.06344 33.1626 10.4427C33.1626 11.822 34.2807 12.9401 35.66 12.9401Z"
      fill="#347D36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.2705 9.73675C36.6604 10.0739 36.7031 10.6633 36.3659 11.0532L31.7992 16.3334C31.462 16.7233 30.8726 16.766 30.4827 16.4288C30.0928 16.0917 30.0501 15.5022 30.3873 15.1124L34.954 9.83214C35.2912 9.44227 35.8806 9.39955 36.2705 9.73675Z"
      fill="#347D36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.8471 26.9026C31.0963 26.4513 31.6641 26.2875 32.1153 26.5366L38.9653 30.3184C39.4166 30.5675 39.5805 31.1353 39.3313 31.5865C39.0822 32.0378 38.5144 32.2017 38.0631 31.9525L31.2131 28.1708C30.7619 27.9216 30.598 27.3538 30.8471 26.9026Z"
      fill="#347D36"
    />
    <path
      d="M10.6861 32.9193C12.0654 32.9193 13.1835 31.8012 13.1835 30.4219C13.1835 29.0426 12.0654 27.9245 10.6861 27.9245C9.30685 27.9245 8.18872 29.0426 8.18872 30.4219C8.18872 31.8012 9.30685 32.9193 10.6861 32.9193Z"
      fill="#347D36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9237 26.4009C18.174 26.8515 18.0117 27.4197 17.5611 27.67L11.1392 31.2378C10.6886 31.4881 10.1204 31.3257 9.87006 30.8751C9.61973 30.4245 9.78208 29.8563 10.2327 29.606L16.6546 26.0383C17.1052 25.7879 17.6734 25.9503 17.9237 26.4009Z"
      fill="#347D36"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6001 30.5589C25.1155 30.5589 25.5334 30.9768 25.5334 31.4922V37.5573C25.5334 38.0728 25.1155 38.4907 24.6001 38.4907C24.0846 38.4907 23.6667 38.0728 23.6667 37.5573V31.4922C23.6667 30.9768 24.0846 30.5589 24.6001 30.5589Z"
      fill="#347D36"
    />
  </svg>,
  "FundraisingIcon"
);

export default FundraisingIcon;
